// @flow
import { reducer as formReducer } from 'redux-form';
import auth from './auth';

export default {
  auth,
  form: formReducer,
};



// WEBPACK FOOTER //
// ./src/reducers/index.js